import { render, staticRenderFns } from "./TestsTabNewTest.vue?vue&type=template&id=636d25f0&"
import script from "./TestsTabNewTest.vue?vue&type=script&lang=js&"
export * from "./TestsTabNewTest.vue?vue&type=script&lang=js&"
import style0 from "./TestsTabNewTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TestsTabNewTest.vue"
export default component.exports